import { Link } from "react-router-dom";
import { MessageCircle, CalendarHeart } from "lucide-react";
import { useI18n } from "../../i18n/LanguageProvider";
import { WHATSAPP_LINK } from "../../config/site";

// Sticky bottom CTA bar — mobile only.
export default function MobileCTA() {
  const { t, p } = useI18n();
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 border-t border-navy/10 bg-white/95 backdrop-blur-xl px-3 py-2.5"
      style={{ paddingBottom: "max(0.625rem, env(safe-area-inset-bottom))" }}
    >
      <div className="flex items-center gap-2.5">
        <a
          href={WHATSAPP_LINK()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-whatsapp-btn"
          className="flex flex-1 items-center justify-center gap-2 rounded-full border-2 border-turquoise py-3 text-sm font-semibold text-turquoise active:scale-[0.98] transition-transform"
        >
          <MessageCircle className="h-4 w-4" />
          {t.cta.whatsapp}
        </a>
        <Link
          to={p("contact")}
          data-testid="sticky-plan-btn"
          className="flex flex-1 items-center justify-center gap-2 rounded-full bg-dental py-3 text-sm font-semibold text-white active:scale-[0.98] transition-transform"
        >
          <CalendarHeart className="h-4 w-4" />
          {t.cta.freePlanShort}
        </Link>
      </div>
    </div>
  );
}
